import { render, staticRenderFns } from "./Football.vue?vue&type=template&id=7a6ca152&scoped=true&"
import script from "./Football.vue?vue&type=script&lang=js&"
export * from "./Football.vue?vue&type=script&lang=js&"
import style0 from "./Football.vue?vue&type=style&index=0&id=7a6ca152&lang=scss&scoped=true&"
import style1 from "./Football.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6ca152",
  null
  
)

export default component.exports